import { Link } from 'react-router-dom';
import { useDashboard } from '@/hooks/useDashboard'; // ✅ 1. Importamos el nuevo hook
import MainMenu from '@components/ui/game/main-menu/MainMenu';
import Loader from '@/components/ui/general/loader/Loader';
import CreateGameForm from '@components/ui/dashboard/create-game-form';
import { GameStatus } from '@utils/enums';
import StatusTag from '@/components/ui/general/status-tag/StatusTag';
import './Dashboard.css';
import { useState } from 'react'; //para botones
import { Trash2 } from 'lucide-react';
import JoinGame from "../components/JoinGame";
import { deleteGame } from '@/api/dashboardApi';
import { useQueryClient } from '@tanstack/react-query';


function Dashboard() {
  const queryClient = useQueryClient();

  // ✅ 2. Toda la lógica compleja ahora está contenida aquí
  const {
    user,
    players,
    activePlayer,
    games,
    gameError,
    newPlayerName,
    setNewPlayerName,
    handleCreatePlayer,
    handleSelectPlayer,
    handleCreateGame,
    createPlayerMutation,
    createGameMutation,
    dashboardMessage,
  } = useDashboard();

  // Si aún no ha cargado la información inicial del usuario
  if (!user) 
    return (
      <div>
        <MainMenu user={null} />
        <div className="dashboard-container">
          <h2>Dashboard</h2>
          <Loader message="Loading User Data..." />
        </div>
      </div>
    );
  

  const [selectedFilter, setSelectedFilter] = useState('all');

  const filteredGames = games.filter(game => {
    if (selectedFilter === 'all') return true; // todas las creadas
    if (selectedFilter === 'public') return game.visibility === 'public';
    if (selectedFilter === 'private') return game.visibility === 'private';
    return true;
  });

  const handleDeleteGame = async (gameId) => {
    if (!window.confirm('¿Estás seguro de eliminar este juego?')) return;

    const result = await deleteGame(gameId);

    if (result) {
      // Refresh the games list after successful deletion
      queryClient.invalidateQueries(['games', activePlayer?.id]);
    }
  };

  


  return( 
    <div>
      <MainMenu />

      <div className="dashboard-container">
        <h2>Dashboard</h2>

        {/* Mensaje dinámico para el usuario */}
        {dashboardMessage && <p className={`message-${dashboardMessage.type}`}>{dashboardMessage.text}</p>}
        
        {createPlayerMutation.error && <p className="error-message">{createPlayerMutation.error.message}</p>}

        <div className="section">
          <h3>Crear nuevo jugador</h3>
          <div className="create-player-form">
            <input
              value={newPlayerName}
              onChange={(e) => setNewPlayerName(e.target.value)}
              placeholder="Nombre del jugador"
              disabled={players.length >= 4 || createPlayerMutation.isPending}
            />
            <button onClick={handleCreatePlayer} disabled={!newPlayerName || players.length >= 4 || createPlayerMutation.isPending}>
              {createPlayerMutation.isPending ? 'Creando...' : 'Crear'}
            </button>
          </div>
          {players.length >= 4 && (
            <p className="warning-message">Ya tienes el máximo de 4 jugadores.</p>
          )}
        </div>


        {!activePlayer ? (
          <div className="section">
            <Loader message="Waiting for player selection..." />
          </div>
        ) : (
          <div className="section">
           <h3>Crear nueva partida</h3>
            <div className="game-list-header">
              <h4>Games of Player</h4>
              <select value={activePlayer.id} onChange={handleSelectPlayer} disabled={players.length <= 1}>
                  {players.map(player => (
                    <option key={player.id} value={player.id}>{player.name}</option>
                  ))}
              </select>
            </div>
            
            {/* Botones para crear partidas */}
            <CreateGameForm
              selectedPlayer={activePlayer.id}
              onCreateGame={handleCreateGame}
              error={createGameMutation.error?.message}
              isLoading={createGameMutation.isPending}
            />

            
          </div>

        )}

      <div className="section">
            {/* Botones de salas publico, privado creados */}
            <h3>Partidas Creadas</h3>
            <div className="game-filters">
            <button
              className={selectedFilter === 'all' ? 'active' : ''}
              onClick={() => setSelectedFilter('all')}
            >
              Creadas
            </button>
            <button
              className={selectedFilter === 'public' ? 'active' : ''}
              onClick={() => setSelectedFilter('public')}
            >
              Públicas
            </button>
              <button
                className={selectedFilter === 'private' ? 'active' : ''}
                onClick={() => setSelectedFilter('private')}
              >
                Privadas
              </button>            
            </div>

            {selectedFilter === 'private' && (
            <div className="private-code-section">
              <h3>🔒 Ingresar a Partida Privada</h3>
              <JoinGame />
            </div>
          )}

            {/* Aquí podrías poner otro loader mientras los juegos cargan si quisieras */}
            <div className="game-list">
              {gameError && <p className="error-message">{gameError.message}</p>}
              {filteredGames.length > 0 ? (
                  <ul>
                  {filteredGames.map(game => {
                    const gameLink = game.status === GameStatus.Lobby ? `/lobby/${game.id}` : `/games/${game.id}`;
                    return (
                      <li className="game-list-item" key={game.id}>
                        <Link to={gameLink}>
                          <span className="game-name">
                            {game.name || `Juego #${game.id}`}
                          </span>
                
                          {game.visibility === "private" && game.access_code && (
                            <span className="game-code">Codigo: {game.access_code}</span>
                          )}
                
                          <StatusTag status={game.status} />
                        </Link>
                        <button 
                          className="btn-delete-game "
                          onClick={() => handleDeleteGame(game.id)}>
                          <Trash2 size={18} />
                        </button>
                      </li>
                    );
                    
                  })}
                </ul>
              ) : (
                <p>No hay juegos para este jugador.</p>
              )}
            </div>
      </div>

      </div>


    </div>
  );
}

export default Dashboard;